/** @format */

import {TanStackTableData} from 'components/Table/core/types';

import {GetYandexHistoryQueryPage} from '../graphql/__generated__';
import {formatValue} from './formatHelpers';
import {SUB_ROWS_THRESHOLD} from '../constants';

type YandexHistoryItem = NonNullable<
  NonNullable<GetYandexHistoryQueryPage['currentUser']>['yandexHistory']
>[0];

export const transformYandexHistoryData = (
  yandexHistory: NonNullable<GetYandexHistoryQueryPage['currentUser']>['yandexHistory'],
): TanStackTableData[] => {
  if (!yandexHistory) return [];

  return yandexHistory
    .filter((item): item is NonNullable<YandexHistoryItem> => item !== null)
    .map(item => {
      const beforeText = item.valueBefore ? formatValue(item.valueBefore) : '';
      const afterText = item.valueAfter ? formatValue(item.valueAfter) : '';
      const isExpandable = beforeText.length + afterText.length > SUB_ROWS_THRESHOLD;

      return {
        id: `${item.accountId}-${item.campaignId}-${item.time}`,
        time: item.time,
        accountId: item.accountId || '',
        accountName: item.accountName || '',
        campaignId: item.campaignId || '',
        campaignName: item.campaignName || '',
        adGroupId: item.adGroupId || '',
        adGroupName: item.adGroupName || '',
        adId: item.adId || '',
        adName: item.adName || '',
        categoryDescription: item.categoryDescription || item.category,
        typeDescription: item.typeDescription || item.type,
        valueBefore: item.valueBefore || {},
        valueAfter: item.valueAfter || {},
        type: item.type,
        isExpandable: isExpandable,
      };
    });
};
